import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { PaymentConfig } from '@nano/payment/payment';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.less'],
  standalone: false
})
export class PaymentDetailsComponent {
  @Input() paymentDetailsControl: AbstractControl;
  @Input() paymentCodeControl: AbstractControl;
  @Input() isPaymentDetailsStructured: boolean;
  @Input() config: PaymentConfig;
  @Output() switchPaymentDetailsType = new EventEmitter<boolean>();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}

  onSwitchPaymentDetailsType(isPaymentDetailsStructured: boolean): void {
    this.isPaymentDetailsStructured = isPaymentDetailsStructured;
    this.switchPaymentDetailsType.emit(isPaymentDetailsStructured);
  }
}
